module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('OrderTable', {
    key: 'order-table-receipt',
    attrs: {
      "title": ("" + (_vm.$t('pages.receipt'))),
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "disableActionBTN": true,
      "isActiveBtn": true,
      "isLoading": _vm.loading
    },
    on: {
      "downloadPdfReceipt": _vm.downloadPdfReceipt,
      "uploadImageReceipt": _vm.uploadImageReceipt,
      "downloadAllReceipt": _vm.downloadAllReceipt,
      "changeVal": _vm.changeValReciept
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d85d6948"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/Receipt.vue
// module id = 595
// module chunks = 0